<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top :color="snackbarColor"> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <ClientNav/>
        <v-row dense>
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>
            <v-col cols="12" lg="9" xl="10">
                <v-card class="pa-2" outlined tile height="100%">
                    <v-data-table
                        :headers="headers"
                        :items="attendances"
                        sort-by="Date"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Attendance"
                        :search="search"
                        height="550"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Attendance</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    clearable
                                    flat
                                    solo-inverted
                                    hide-details
                                    prepend-inner-icon="search"
                                    label="search"
                                    class="desktop"
                                ></v-text-field>
                                <v-spacer></v-spacer>
                                <report-list-actions
                                    :reportOptions="reportOptions"
                                    :downloadFilename="reportListFilename"
                                ></report-list-actions>
                              <v-btn v-if="!isAuditorRole" color="#2b3990" dark @click="showAdd()">
                                <v-icon left>add</v-icon>
                                <span class="hidden-sm-and-down">Add Attendance</span>
                                <span class="hidden-md-and-up">Add</span>
                              </v-btn>
                            </v-toolbar>
                            <v-text-field
                                v-model="search"
                                clearable
                                flat
                                solo-inverted
                                hide-details
                                prepend-inner-icon="search"
                                label="search"
                                class="mobile ml-5 mr-5 mb-3 mt-3"
                            ></v-text-field>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="viewAttendance(item)">
                                mdi-eye
                            </v-icon>
                            <v-icon small @click="deleteAttendance(item)" v-if="!client && !isAuditorRole">
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="#2b3990" class="white--text" @click="getAttendance()">Reset</v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <add-service-code-dialog/>

        <Foot class="hideOnPrint"/>
        <report-table
            :reportHeaderText="reportHeaderText"
            :tableHeaders="reportTableHeader"
            :tableData="reportData"
        />

    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import AddServiceCodeDialog from '../../components/client/attendance/AddServiceCodeDialog';
import Foot from '../../components/Footer'
import moment from 'moment'
import ReportTable from '@/components/Report/ReportTable.vue';
import ReportListActions from '@/components/Report/ReportListActions.vue';
//import { mapState, mapActions, mapGetters } from "vuex";
const url = require("../../client_config/config").url;
export default {
    components: {
        ClientNav,
        ClientSide,
        AddServiceCodeDialog,
        Foot,
        ReportTable,
        ReportListActions
    },
    data: function () {
        return {
            headers: [
                {
                    text: 'Date',
                    align: 'start',
                    sortable: true,
                    value: 'Date',
                    width: 120
                },
                // { text: "Service Code Name", value: "Name" },
                {text: "Service Code", value: "Code"},
                {text: "Units", value: "Units"},
                {text: "Unit of Service", value: "ServiceUnit"},
                {text: "Start Time", value: "TimeStart"},
                {text: "End Time", value: "TimeEnd"},
                {text: "Signature", value: "Signature"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            //dialog: false,
            editAttendance: false,
            newAttendance: false,
            msg: false,
            snackbarColor: "black",
            search: "",
            text: "",
            attendances: [],
            codes: [],
            users: [],
            clientID: this.$route.params.clientID,
            userID: localStorage.getItem('userID'),
            staff: localStorage.getItem('Name'),
            tempData: [],
            titleForm: "New Attendance Record",
            attendanceID: "",
            newName: "",
            newTitle: "",
            newUnits: "",
            newCode: "",
            newDate: "",
            newSignature: "",
            Rate: "",
            signed: false,
            checkSignature: false,
            //newUnits: "",
            newServiceUnit: "",
            isLoading: true,
            requiredRules: [
                v => !!v || 'This is required',
            ],
            timeStartPicker: false,
            timeStart: "",
            timeEndPicker: false,
            timeEnd: "",
            timeEndAdjust: null,
            requiredTime: false,
            newServiceCodeDialog: false,
            newServiceCodeAdd: "",
            maskDate: [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
            maskTimeStart: [/[1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /[A,P]/, 'M'],
            maskTimeEnd: [/[1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /[A,P]/, 'M'],
            showStartTimePicker: false,
            showEndTimePicker: false,
            timeStartDisplay: '',
            timeEndDisplay: '',
            readonly: true,
            disabled: true,
            client: false,
        }
    },
    computed: {
        reportHeaderText() {
            return 'Client Attendance';
        },
        reportData() {
            return this.attendances
        },
        reportTableHeader() {
            return this.headers.slice(0, this.headers.length-1);
        },
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        },
        reportOptions() {
            return { 
                query: {
                name: this.employeeName,
                },
                endpoints: `attendance/printList/${this.clientID}`,
                dynamic: true
            }
        },
        reportListFilename() {
            return `Client Attendance - ${moment().format('YYYY-MM-DD')}`;
        }
    },
    watch: {},
    created() {
        this.getAttendance();
        if (localStorage.getItem('userRole') === 'Administration' ||
            localStorage.getItem('userRole') === 'Client Services Manager' ||
            localStorage.getItem('userRole') === 'Program Coordinator' ||
            localStorage.getItem('userRole') === 'Human Resources' ||
            localStorage.getItem('userRole') === 'Compliance Manager') {

            this.readonly = false
            this.disabled = false
        }
        if (localStorage.getItem('userRole') === "Client") {
            this.client = true;
        }
        this.getCodes();
    },
    methods: {
        initialize() {
            this.attendances = [];
        },

        validate() {
            return this.$refs.form.validate()
        },

        viewAttendance(item) {
            this.$router.push({
                path: `/attendance/${this.clientID}/update/${item._id}`,
                query: {createAttendance: false} })
        },

        calcUnits() {
            let timeDiff = moment.duration(moment.utc(moment(this.timeEnd, "HH:mm").diff(moment(this.timeStart, "HH:mm"))).format("HH:mm")).asMinutes();
            if (this.newServiceUnit == 'Quarter Hour') {
                this.newUnits = parseInt(timeDiff) / 60
            } else if (this.newServiceUnit == 'Session') {
                this.newUnits = parseInt(timeDiff) / 30
            } else if (this.newServiceUnit == 'Hourly') {
                this.newUnits = parseInt(timeDiff) / 60
            } else {
                this.newUnits = 1
            }
            this.calcForError()

        },

        calcDailyUnits() {
            this.newTitle = this.newCode.Title
            this.getUnitType()
            if (this.newServiceUnit == 'Daily') {
                this.newUnits = 1
            } else {
                this.newUnits = 0
                this.timeStart = ""
                this.timeEnd = ""
            }
        },

        getUnitType() {
            this.newServiceUnit = this.newCode.Units;
            if (this.newCode != "") {
                console.log(this.newCode.Units + " service Unit")
                switch (this.newServiceUnit) {
                    case "Quarter Hour":
                        this.requiredTime = true;
                        break;
                    case "Session":
                        this.requiredTime = true;
                        break;
                    case "Hourly":
                        this.requiredTime = true;
                        break;
                    case "Daily":
                        this.requiredTime = false;
                        break;
                    default:
                        return 0;
                }
            }

        },

        calcForError() {
            if (moment(this.timeStart, 'hh:mma').isAfter(moment(this.timeEnd, 'hh:mma')) ||
                moment(this.timeStart, 'hh:mma').isSame(moment(this.timeEnd, 'hh:mma'))) {

                this.msg = true;
                this.text = 'Please make sure the end time is after the start time';
                this.newUnits = 0
            }
        },

        showAdd() {
            this.$router.push({
                path: `/attendance/${this.clientID}/new`,
                query: {createAttendance: true}
            });
        },

        deleteAttendance(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this attendance record?") &&
            this.attendanceDelete(id);
        },

        attendanceDelete(id) {
            axios.delete(`${url}/attendance/${id}`)
                .then((response) => {
                    this.getAttendance();
                    if (response.status == 400) {
                        response.json().then(function (data) {
                            return data.msg;
                        });
                    }
                    this.snackbarColor = "black";
                    this.msg = true;
                    this.text = "The attendance record has been deleted successfully.";
                });
        },


        getAttendance() {
            this.isLoading = true;
            axios.get(`${url}/attendance/client/${this.clientID}`).then(res => {
                this.attendances = [];
                    this.tempData = res.data.attendances;

                for (var i = 0; i < this.tempData.length; i++) {
                    this.tempData[i].Date = moment(this.tempData[i].Date).format('YYYY-MM-DD');
                    this.attendances.push(this.tempData[i]);
                }
            }).finally(() => this.isLoading = false);
        },

        getCodes() {
            axios.get(`${url}/serviceCodes/get/allClientCodes/${this.clientID}`).then(async res => {
                this.codes = res.data.activeServiceCodes;
            });
        },

        printTable() {
            document.getElementById('printTable').style.display = "block";
            window.print()
            document.getElementById('printTable').style.display = "none";
        }
    },
};
</script>
<style>
#printTable{
    display: none;
}
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

@media print {
    #printTable {
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
    }

    .hideOnPrint {
      display: none;
      border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none;

    }

    @page { margin: 0; }
    body { margin: 1.6cm; }
}
</style>
